import React from 'react';
import { Component } from '@poa/core';
import { Observer, observer, observable } from '@poa/state';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';

import LikeIcon from './icons/like';

const DragHandle = SortableHandle(() => <span>::</span>);

export const ColumnItem = observer(
  class ColumnItem extends React.Component {
    moveCaretAtEnd(e) {
      const tempValue = e.target.value;

      e.target.value = '';
      e.target.value = tempValue;
    }

    render() {
      const { item, editable, hideDragHandle } = this.props;
      const { isEdit } = this.props;

      let dragHandle = null;

      if (!hideDragHandle) {
        dragHandle = <DragHandle />;
      }

      if (isEdit) {
        return (
          <div onKeyDown={this.props.handleKeyboard} style={{ display: 'flex' }}>
            {dragHandle}
            <div style={{ display: 'flex' }}>
              <Observer>
                {() => (
                  <input
                    autoFocus
                    onFocus={this.moveCaretAtEnd}
                    className="filter-columns__text"
                    style={{
                      width: '143px',
                      border: '1px solid #ccc',
                      textTransform: 'none',
                      marginLeft: '10px'
                    }}
                    value={item.label}
                    onChange={({ currentTarget }) => (item.label = currentTarget.value)}
                  />
                )}
              </Observer>
              <Observer>
                {() => (
                  <input
                    style={{
                      width: '35px',
                      marginLeft: '10px',
                      border: '1px solid #ccc'
                    }}
                    type="number"
                    value={item.width}
                    onChange={({ currentTarget }) =>
                      (item.width = parseInt(currentTarget.value, 10))
                    }
                  />
                )}
              </Observer>
            </div>
          </div>
        );
      }

      return (
        <div>
          {dragHandle}
          <span
            className="filter-columns__text"
            style={{ width: 'calc(100% - 30px)', textTransform: 'none', marginLeft: '10px' }}
            onClick={editable ? this.props.onLabelClick : undefined}
          >
            {item.label}
          </span>
        </div>
      );
    }
  }
);

class ColumnOption extends React.Component {
  lastOriginalLabel = '';
  lastOriginalWidth = 0;
  localState = observable({ isEdit: false });

  componentDidUpdate() {
    if (!this.props.isDropdownOpen && this.localState.isEdit) {
      this.disableEditing();
    }
  }

  handleChange = () => this.props.onChange(this.props.data);

  disableEditing() {
    this.props.data.label = this.lastOriginalLabel;
    this.props.data.width = this.lastOriginalWidth;

    this.localState.isEdit = false;

    document.removeEventListener('click', this.handleOutsideClick);
  }

  onLabelClick = event => {
    event.preventDefault();

    document.addEventListener('click', this.handleOutsideClick);

    this.lastOriginalLabel = this.props.data.label;
    this.lastOriginalWidth = this.props.data.width;
    this.localState.isEdit = true;
  };

  handleOutsideClick = e => {
    if (this.node && this.node.contains(e.target)) {
      return;
    }

    this.disableEditing();
  };

  handleKeyboard = event => {
    switch (event.key) {
      case 'Enter':
        event.preventDefault();
        event.stopPropagation();

        document.removeEventListener('click', this.handleOutsideClick);
        this.localState.isEdit = false;

        break;
      case 'Escape':
        event.preventDefault();
        event.stopPropagation();

        this.disableEditing();

        break;
      default:
        break;
    }
  };

  render() {
    const { name, isSelected } = this.props.data;
    const { isDropdownOpen } = this.props;

    return (
      <label className="filter-columns__row" ref={node => (this.node = node)}>
        {!this.localState.isEdit && (
          <input
            type="checkbox"
            name={name}
            className="filter-columns__check"
            checked={isSelected}
          />
        )}
        <ColumnItem
          item={this.props.data}
          editable={!name.includes('separator')}
          isDropdownOpen={isDropdownOpen}
          isEdit={this.localState.isEdit}
          onLabelClick={this.onLabelClick}
          moveCaretAtEnd={this.moveCaretAtEnd}
          handleKeyboard={this.handleKeyboard}
        />
        {!this.localState.isEdit && (
          <span className="filter-columns__checkbox" onClick={this.handleChange}>
            <LikeIcon />
          </span>
        )}
      </label>
    );
  }
}

ColumnOption = SortableElement(Component({ namespaces: ['tableFilter'] })(ColumnOption));

class ColumnsList extends React.Component {
  renderColumnOption = (column, index) => {
    return (
      <ColumnOption
        key={column.name}
        index={index}
        data={column}
        isDropdownOpen={this.props.isDropdownOpen}
        onChange={this.props.onColumnChange}
      />
    );
  };

  render() {
    return <div>{this.props.columns.map(this.renderColumnOption)}</div>;
  }
}

ColumnsList = SortableContainer(Component({ namespaces: ['tableFilter'] })(ColumnsList));

class ColumnsContainer extends React.Component {
  t;

  handleColumnPresetSubmit = e => {
    let presetName = prompt('ARE U SURE ABOUT THAT');
    e.preventDefault();

    while (presetName === '') {
      presetName = prompt('The name is required');
    }

    if (presetName) {
      const columnPreset = { label: presetName, columns: [] };

      for (let i = 0; i < this.props.selectors.currentPresetColumnsList.length + 1; i++) {
        const element = e.target.elements[i];

        if (element.checked) {
          columnPreset.columns.push(element.name);
        }
      }

      this.props.onColumnPresetSubmit(columnPreset);
    }
  };

  render() {
    const { columns, isDropdownOpen } = this.props;

    return (
      <form id="local-config-form" onSubmit={this.handleColumnPresetSubmit}>
        <ColumnsList
          columns={columns}
          onSortEnd={this.props.onSortEnd}
          useDragHandle={true}
          isDropdownOpen={isDropdownOpen}
          onColumnChange={async (...args) => {
            await this.props.onColumnChange(...args);
            this.props.getTableNode().recalculateScroll();
          }}
        />
        <button type="submit" className="filter-columns__save">
          {this.t('saveAs')}
        </button>
      </form>
    );
  }
}

export default Component({ namespaces: ['tableFilter'] })(ColumnsContainer);
